import { useLocation, useNavigate } from "react-router-dom";
import useJellyIndicator from "./useJellyIndicator";
import "./IconBar.css";

/* Adapted from Bencho's MIT-licensed Icon bar: https://bencho.dev/licence */
export default function IconBar({ items }) {
  const location = useLocation();
  const navigate = useNavigate();
  const activePath = items.find((item) => item.to === location.pathname)?.to || null;
  const { trackRef, itemRefs, phase, variables, indicatorStyle } = useJellyIndicator(activePath);

  const select = (event, path) => {
    // Preserve the browser's open-in-new-tab and modified-click behaviour.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (path !== activePath) navigate(path);
  };

  return (
    <nav ref={trackRef} className="icon-bar" style={variables} aria-label="Navegação principal">
      <span className="icon-bar__indicator" data-phase={phase} style={indicatorStyle} aria-hidden="true" />
      {items.map((item) => (
        <a
          key={item.to}
          href={item.to}
          ref={(element) => { itemRefs.current[item.to] = element; }}
          className="icon-bar__item"
          data-active={activePath === item.to}
          data-testid={item.testid}
          aria-current={activePath === item.to ? "page" : undefined}
          onClick={(event) => select(event, item.to)}
        >
          {item.label}
        </a>
      ))}
    </nav>
  );
}
